<template>
  <div id="news">
    <div class="trader-ban">
      <!--      <img src="//30639.oss-cn-hongkong.aliyuncs.com/front/mx22.jpg">-->
    </div>
    <div class="addressSite">
      <div class="poster" v-for="(item,index) in cur_list" :key="index" @click="toDetail(item.id)">
        <div>{{item.title}}</div>
        <img src="../assets/img/right-nav.png">
        <div>{{item.time}}</div>
      </div>
      <el-pagination v-if="list.length"
                     background
                     layout="prev, pager, next"
                     :page-size="size"
                     :page-count="sum"
                     @current-change="getList"></el-pagination>
    </div>
  </div>
</template>
<script>

  import $ from "jquery";
  export default {
    name: "News",
    components: {
    },
    data() {
      return {
        list: [],
        cur_list: [],
        sum: 0,
        page: 1,
        size: 10
      };
    },
    activated() {
      // $("#wrapper").css("background", "#737373");
      $("body,html").css({ overflow: "inherit", height: "100%" });
    },
    mounted() {
      let that = this;
      that.getNews();

    },
    methods: {
      getList(i) {
        this.page = i;
        this.getNews();
        // this.page = i-1;
        // this.cur_list = this.list.slice(
        //   Number(this.size) * Number(i-1),
        //   Number(this.size) * Number(i-1) + Number(this.size)
        // );

      },
      toDetail(i) {
        sessionStorage.setItem("activenews", i);
        sessionStorage.setItem("newsCatId", sessionStorage.getItem("newsCatId"));
        this.$router.push({
          name:"Newsdetails"
        })
      },
      getNews(){
        let that = this;
        let page = that.page;
        that
          .$http({
            url: "/",
            method: "post",
            data: {
              nozzle: "news",
              page:page,
              category:sessionStorage.getItem("newsCatId"),
            }
          })
          .then(function(res) {
            if (res.data.code == 1) {
              if (res.data.data.data.data.length) {
                that.list = res.data.data.data.data;
                sessionStorage.setItem("news",JSON.stringify(that.list));
                that.cur_list = that.list.slice(0, that.size);
                that.sum = res.data.data.data.page;
              }
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
      }
    }
  };
</script>
<style scoped>
  @import url("./../assets/css/aboutus.css");
</style>





// WEBPACK FOOTER //
// src/components/news.vue